export enum EventTypeEnum {
  ESTADUAL = "ESTADUAL",
  NACIONAL = "NACIONAL",
  INTERNACIONAL = "INTERNACIONAL",
  // REGIONAL = "REGIONAL",
  // MUNICIPAL = "MUNICIPAL",
  // INTERMUNICIPAL = "INTERMUNICIPAL",
}
